import orderBy from "lodash/orderBy";
import each from "lodash/each";
const sanitizeHtml = require("sanitize-html");

export const formatProductDisplayName = product => {
  const { type, periodInMonths } = product;
  let durationStr = periodInMonths > 0 ? `${periodInMonths} kk` : null;
  if (type === "cancelPrevent") {
    return `peruut. esto. ${durationStr}`;
  }
  if (type === "svod") {
    return `SVOD`;
  }
  if (type === "edu") {
    return "Koulutus";
  } 
  else if (type === "") {
    return "KUMPPANI";
  }
  if (durationStr === null) {
    return "Toist. voimassa";
  }
  return durationStr;
};

export const formatPlainText = (text, paragraphWrap = true) => {
  let formatted = paragraphWrap ? `<p>${text}</p>` : `${text}`;
  formatted = formatted.replace(/\r\n\r\n/g, "</p><p>").replace(/\n\n/g, "</p><p>");
  formatted = formatted.replace(/\r\n/g, "<br />").replace(/\n/g, "<br />");

  return formatted;
};

export const sortTableAndHead = (headItem, tableHeadData, tableData) => {
  each(tableHeadData, function(head) {
    if (head.name === headItem.name) {
      head.sort = head.sort === "asc" ? "desc" : "asc";
      tableData = orderBy(tableData, head.name, head.sort);
    } else {
      head.sort = "";
    }
  });

  const sort = {
    head: tableHeadData,
    data: tableData
  };
  // console.log("sortTableAndHead, sort", sort);
  return sort;
};

export const sanitizeHtmlContent = html => {
  const clean = sanitizeHtml(html, {
    allowedTags: [
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "blockquote",
      "p",
      "a",
      "ul",
      "ol",
      "nl",
      "li",
      "b",
      "i",
      "strong",
      "em",
      "strike",
      "hr",
      "br"
    ],
    allowedAttributes: {
      a: ["href", "name", "target"]
    }
  });
  return clean;
};



// WEBPACK FOOTER //
// ./src/utils/content-utils.js